import { Injectable } from '@angular/core';
import { AuthorizationDataService } from './authorizationData.service';

@Injectable({
	providedIn: 'root',
})
export class AuthorizationService {

	constructor(private authorizationDataService: AuthorizationDataService) { }

	private _roles!: string[];
	private _initialized: boolean = false;

	inRole(role: string): Promise<boolean> {
		//if (this._initialized) {
		//	return Promise.resolve(this._inRole(role));
		//} else {
		//	const promise = new Promise<boolean>((resolve, reject) => {
		//		this.authorizationDataService.getRoles()
		//			.then(roles => {
		//				this._roles = roles;
		//				this._initialized = true;
		//				resolve(this._inRole(role));
		//			})
		//			.catch((e) => {
		//				reject(e);
		//			});
		//	});
			return Promise.resolve(false);
		//}
	}

	private _inRole(role: string): boolean {
		if (role == null) { return true; }

		if (this._roles != null) {
      let requiredRoles = role.split(',');
      for (let userIndex in this._roles) {
        for (let requiredIndex in requiredRoles) {
          if (requiredRoles[requiredIndex].trim().toLowerCase() === this._roles[userIndex].trim().toLowerCase()) {
            return true;
          }
        }
      }
		}
		return false;
	}

	getRoles(): Promise<string[]> {
		//if (this._initialized) {
		//	return Promise.resolve(this._roles);
		//} else {
		//	const promise = new Promise<string[]>((resolve, reject) => {
		//		this.authorizationDataService.getRoles()
		//			.then(roles => {
		//				this._roles = roles;
		//				this._initialized = true;
		//				resolve(this._roles);
		//			})
		//			.catch((e) => {
		//				reject(e);
		//			});
		//	});
			return Promise.resolve([]);
		//}
	}
}
